<template>
  <Fragment>
    <template v-if="$route.name !== 'brandIndex'">
      <router-view></router-view>
    </template>
    <section v-else>
      <Breadcrumb />
      <div class="card-wrap mt-20 mb-20">
        <section class="card-content">
          <div class="left">
            <div class="search-name mr-15">
              <span>品牌名称：</span>
              <el-input v-model="brandName"> </el-input>
            </div>
            <div class="search-name mr-15">
              <span>品牌编码：</span>
              <el-input v-model="brandCode"> </el-input>
            </div>
            <el-button
              type="primary"
              class="ml-20"
              @click="searchBaseDataBrandInfo"
              >查询</el-button
            >
          </div>
          <el-button type="primary" class="mr-20" @click="addBrand"
            >添加品牌</el-button
          >
        </section>
      </div>
      <el-table :data="list" style="width: 100%" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌名称" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.brandName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="品牌编码" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.brandCode }}</span>
          </template>
        </el-table-column>
        <el-table-column label="跳转地址" :fit="true">
          <template slot-scope="scope">
            <span>{{ scope.row.brandUrl }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="editBrandInfo(scope.row)"
              >编辑</el-button
            >
            <el-button size="mini" type="danger" @click="deleteBrand(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </section>
  </Fragment>
</template>

<script>
import { Fragment } from "vue-fragment";

import Breadcrumb from "@/components/Breadcrumb";
export default {
  name: "role",
  components: {
    Breadcrumb,
    Fragment
  },
  data() {
    return {
      brandName: "",
      brandCode: "",
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    getBaseDataBrandList() {
      let _this = this;
      let param = {
        url: "/api/brand/getBrandLandingPage",
        params: {
          brandName: _this.brandName,
          brandCode: _this.brandCode,
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getBaseDataBrandList", param).then(() => {
        _this.list = _this.$store.state.brand.baseDataBrandList.list;
        _this.total = _this.$store.state.brand.baseDataBrandList.total;
      });
    },
    //查询
    searchBaseDataBrandInfo() {
      let _this = this;
      _this.getBaseDataBrandList();
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getBaseDataBrandList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getBaseDataBrandList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getBaseDataBrandList();
    },
    //编辑
    editBrandInfo(row) {
      this.$router.push({
        name: "editBrandInfo",
        params: { brandId: row.brandId }
      });
    },
    //删除
    deleteBrand: function(row) {
      let _this = this;
      if (confirm("确定要删除吗") === true) {
        let param = {
          url: "/api/brand/deleteBrandInfoById",
          params: { brandId: row.brandId }
        };

        _this.$Api
          .get(param.url, param.params)
          .then(response => {
            if (response.status === 200) {
              _this.getBaseDataBrandList();
              _this.$message({
                message: "品牌信息删除成功",
                type: "success"
              });
              this.$router.push({
                name: "brandIndex"
              });
            } else {
              _this.$message({
                message: response.data.msg,
                type: "error"
              });
            }
          })
          .catch(err => {});
      }
    },
    //添加
    addBrand() {
      this.$router.push({
        name: "addBrandInfo"
      });
    }
  },
  created() {
    let _this = this;
    _this.getBaseDataBrandList();
  }
};
</script>

<style lang="sass" scoped>
.card-wrap
  .card-content
    display: flex
    align-items: center
    justify-content: space-between
    .left
      display: flex
    .el-button
      font-size: 14px
    .search-name, .search-code
      font-size: 14px
      display: flex
      align-items: center
      span
        white-space: nowrap
.pagination
  text-align: center
</style>
